module.exports = __webpack_public_path__ + "static/Pawprint-ad69cf252f927e841ccdfa3164ed4c70.jpg";